import { get, groupBy, map, mapKeys, mapValues } from 'lodash'

import { toLines } from '../../../../common/utils'

import { INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASE_FIELD_NAMES } from '../../../constants'

const ingredientCommonNegativeSynonymPhrasesInitialValues = data =>
  mapKeys(
    mapValues(groupBy(data, 'type'), phrases =>
      toLines(map(phrases, 'phrase')),
    ),
    (value, key) =>
      get(INGREDIENT_COMMON_NEGATIVE_SYNONYM_PHRASE_FIELD_NAMES, key),
  )

export default ingredientCommonNegativeSynonymPhrasesInitialValues
